import { render, staticRenderFns } from "./commercialeDirettoreDistributori.vue?vue&type=template&id=28c578fc&"
import script from "./commercialeDirettoreDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./commercialeDirettoreDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports